type IconSize = 'sm' | 'md' | 'lg' | 'xl' | number;

interface FileUploadIconProps {
    size?: IconSize;
    className?: string;
}

export const FileUploadIcon: React.FC<FileUploadIconProps> = ({
    size = 'md',
    className
}) => {
    const getSize = (size: IconSize) => {
        const sizes = {
            sm: 32,
            md: 48,
            lg: 64,
            xl: 96
        };

        // If size is a number, use it directly
        if (typeof size === 'number') return size;

        return sizes[size];
    };

    const width = getSize(size);
    const height = width * (503 / 815); // maintain aspect ratio

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 815 503"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g filter="url(#filter0_f_5506_4031)">
                <ellipse cx="407.5" cy="251.612" rx="263.5" ry="107.508" fill="#6D5DF3" />
            </g>
            <path d="M444.222 97.7487C445.784 86.6091 456.08 78.8447 467.22 80.4065L583.758 96.7452L618.286 143.862L652.813 190.978L626.42 379.233C624.858 390.373 614.562 398.137 603.422 396.575L426.373 371.753C415.233 370.191 407.469 359.895 409.031 348.755L444.222 97.7487Z" fill="url(#paint0_radial_5506_4031)" />
            <path d="M444.222 97.7487C445.784 86.6091 456.08 78.8447 467.22 80.4065L583.758 96.7452L618.286 143.862L652.813 190.978L626.42 379.233C624.858 390.373 614.562 398.137 603.422 396.575L426.373 371.753C415.233 370.191 407.469 359.895 409.031 348.755L444.222 97.7487Z" fill="url(#paint1_radial_5506_4031)" />
            <g filter="url(#filter1_d_5506_4031)">
                <path d="M575.606 154.898L583.759 96.7446L652.814 190.978L596.902 183.139C583.223 181.221 573.688 168.577 575.606 154.898Z" fill="url(#paint2_linear_5506_4031)" />
            </g>
            <path d="M150.518 122.629C149.247 111.453 157.276 101.362 168.453 100.09L285.377 86.7879L330.583 123.781L375.789 160.775L397.277 349.652C398.549 360.829 390.519 370.92 379.343 372.191L201.708 392.4C190.532 393.672 180.44 385.642 179.169 374.466L150.518 122.629Z" fill="url(#paint3_radial_5506_4031)" />
            <path d="M150.518 122.629C149.247 111.453 157.276 101.362 168.453 100.09L285.377 86.7879L330.583 123.781L375.789 160.775L397.277 349.652C398.549 360.829 390.519 370.92 379.343 372.191L201.708 392.4C190.532 393.672 180.44 385.642 179.169 374.466L150.518 122.629Z" fill="url(#paint4_radial_5506_4031)" />
            <g filter="url(#filter2_d_5506_4031)">
                <path d="M292.015 145.133L285.377 86.7878L375.789 160.775L319.693 167.157C305.968 168.718 293.576 158.858 292.015 145.133Z" fill="url(#paint5_linear_5506_4031)" />
            </g>
            <path d="M295.314 84.3674C295.314 73.1188 304.433 64 315.681 64H433.36L474.094 105.866L514.829 147.733V337.829C514.829 349.077 505.71 358.196 494.462 358.196H315.681C304.433 358.196 295.314 349.077 295.314 337.829V84.3674Z" fill="url(#paint6_radial_5506_4031)" />
            <g filter="url(#filter3_d_5506_4031)">
                <path d="M433.36 122.722V64L514.83 147.733H458.371C444.558 147.733 433.36 136.535 433.36 122.722Z" fill="url(#paint7_linear_5506_4031)" />
            </g>
            <defs>
                <filter id="filter0_f_5506_4031" x="0.655991" y="0.759995" width="813.688" height="501.704" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="71.672" result="effect1_foregroundBlur_5506_4031" />
                </filter>
                <filter id="filter1_d_5506_4031" x="566.928" y="92.5286" width="94.3174" height="111.097" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4.216" />
                    <feGaussianBlur stdDeviation="4.216" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.427451 0 0 0 0 0.364706 0 0 0 0 0.952941 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5506_4031" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5506_4031" result="shape" />
                </filter>
                <filter id="filter2_d_5506_4031" x="276.945" y="82.5718" width="107.276" height="97.3955" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4.216" />
                    <feGaussianBlur stdDeviation="4.216" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.427451 0 0 0 0 0.364706 0 0 0 0 0.952941 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5506_4031" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5506_4031" result="shape" />
                </filter>
                <filter id="filter3_d_5506_4031" x="424.928" y="59.784" width="98.3337" height="100.597" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4.216" />
                    <feGaussianBlur stdDeviation="4.216" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.427451 0 0 0 0 0.364706 0 0 0 0 0.952941 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5506_4031" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5506_4031" result="shape" />
                </filter>
                <radialGradient id="paint0_radial_5506_4031" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(535.297 225.037) rotate(131.671) scale(198.611 182.689)">
                    <stop stopColor="#D7D2FE" />
                    <stop offset="1" stopColor="#C6BFFA" />
                </radialGradient>
                <radialGradient id="paint1_radial_5506_4031" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(535.297 225.037) rotate(131.671) scale(198.611 182.689)">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#DAD6FF" />
                </radialGradient>
                <linearGradient id="paint2_linear_5506_4031" x1="607.76" y1="144.104" x2="571.038" y2="180.853" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D7D2FE" />
                    <stop offset="1" stopColor="#C6BFFA" />
                </linearGradient>
                <radialGradient id="paint3_radial_5506_4031" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(270.513 223.119) rotate(117.2) scale(198.611 182.689)">
                    <stop stopColor="#D7D2FE" />
                    <stop offset="1" stopColor="#C6BFFA" />
                </radialGradient>
                <radialGradient id="paint4_radial_5506_4031" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(270.513 223.119) rotate(117.2) scale(198.611 182.689)">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#DAD6FF" />
                </radialGradient>
                <linearGradient id="paint5_linear_5506_4031" x1="323.18" y1="125.132" x2="295.726" y2="156.709" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D7D2FE" />
                    <stop offset="1" stopColor="#C6BFFA" />
                </linearGradient>
                <radialGradient id="paint6_radial_5506_4031" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(403.18 197.777) rotate(123.69) scale(198.611 182.689)">
                    <stop stopColor="#CEC8FF" />
                    <stop offset="1" stopColor="#A094FF" />
                </radialGradient>
                <linearGradient id="paint7_linear_5506_4031" x1="481.281" y1="97.728" x2="443.277" y2="135.612" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CEC8FF" />
                    <stop offset="1" stopColor="#A094FF" />
                </linearGradient>
            </defs>
        </svg>
    );
};